import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { UtilService } from "../service/util.service";
import { SeguridadService } from "../service/seguridad.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private seguridadService: SeguridadService,
    private utilService: UtilService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token;
    token = this.seguridadService.getToken();

    if (token) {
      if (!this.seguridadService.isAuthenticated()) {
        //this.utilService.alertWarnning('Al no encontrar actividad, hemos cerrado tu sesión.');
        //this.utilService.link(URL_COMUN.URL_LOGIN);
      }
    }
    return next.handle(req);
  }

}